import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/customer";
const options = { role: ROLE.RESTAURANT };

export const list = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const changeStatus = async (values) => {
  return await axiosInstance(options).patch(`${path}/change-status`, values);
};

export const removeCustomer = async (values) => {
  return await axiosInstance(options).delete(`${path}/delete?o_id=${values.o_id}`);
};
